import { HttpGetParticipantsService } from './http-get-participants.service';
import { ParticipantDTO } from 'app/core/models/participant-dto';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Participant } from 'app/core/models/participant';
import { Injectable } from '@angular/core';

@Injectable({
  	providedIn: 'root'
})

export class GetParticipantsService {

  	constructor(
		private httpGetParticipantsService: HttpGetParticipantsService
	) { }

	public obtain$(): Observable<Participant[]> {

		return this.httpGetParticipantsService.obtain$().pipe(
			map((dtos: ParticipantDTO[]) => dtos.map(dto => Participant.createFromDTO(dto))),
			catchError(err => {
				console.error('[GetParticipantsService] Error obtaining participants', err);
				return throwError(() => new Error('An error has occurred while trying to obtain the participants'));
			})
		);

	}

}